import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useContext, useState } from "react";

import Colors from "../../../../../../../../../global/Colors";
import { LawFirmsDispatchContext, LawFirmsStateContext } from "../context/LawFirmsProvider";
import { setOrderingBy, setOrderingDirection, setSelectedTeams } from "../state/actions";

const AssignedLawFirms = ({ showDeleteButton }) => {
  const state = useContext(LawFirmsStateContext);
  const dispatch = useContext(LawFirmsDispatchContext);
  const [checked, setChecked] = useState([]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    setSelectedTeams(dispatch, newChecked);

    const shouldShowDelete = newChecked.length > 0 ? true : false;
    showDeleteButton(shouldShowDelete);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = state.orderingBy === property && state.orderingDirection === "asc";
    setOrderingDirection(dispatch, isAsc ? "desc" : "asc");
    setOrderingBy(dispatch, property);
  };

  const FormatPhoneNumber = (phoneNumberString) => {
    if (phoneNumberString) {
      const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        const intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
      }
    }
    return " ";
  };
  const TableHeader = () => {
    return (
      <TableHead>
        <TableRow>
          {state.columns &&
            Object.keys(state.columns).length > 0 &&
            Object.keys(state.columns).map((col) => (
              <TableCell
                key={state.columns[col].field_name}
                sortDirection={
                  state.orderingBy === state.columns[col].field_name
                    ? state.orderingDirection
                    : false
                }
              >
                <div className="text-center font-bold">{state.columns[col].display}</div>
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
    );
  };
  const createColumns = (cell, rowIndex) => {
    const fieldName = cell.team.law_firm;
    return (
      <TableRow key={rowIndex + "_" + cell.pk} className="py-0">
        <TableCell
          key={fieldName + "_" + cell.pk}
          sx={{ border: 1, borderColor: Colors.slate[300] }}
          className="w-[5%] py-0"
        >
          <Checkbox
            edge="start"
            checked={checked.includes(cell)}
            tabIndex={-1}
            onClick={handleToggle(cell)}
            disableRipple
            inputProps={{ "aria-labelledby": fieldName.pk }}
          />
        </TableCell>
        <TableCell
          key={fieldName + "_name_" + cell.pk}
          sx={{ border: 1, borderColor: Colors.slate[300] }}
          className="w-[25%] py-0"
        >
          <div>{fieldName.name}</div>
        </TableCell>
        <TableCell
          key={fieldName + "_email_" + cell.pk}
          sx={{ border: 1, borderColor: Colors.slate[300] }}
          className="w-[25%] whitespace-nowrap py-0 text-center"
        >
          <div>{fieldName.email}</div>
        </TableCell>
        <TableCell
          key={fieldName + "_phone_" + fieldName.pk}
          sx={{ border: 1, borderColor: Colors.slate[300] }}
          className="w-[15%] whitespace-nowrap py-0 text-center"
        >
          <div>{FormatPhoneNumber(fieldName.phone)}</div>
        </TableCell>
        <TableCell
          key={fieldName + "_address_" + fieldName.pk}
          sx={{ border: 1, borderColor: Colors.slate[300] }}
          className="w-[30%] py-0 text-center"
        >
          <div>{fieldName.address}</div>
        </TableCell>
      </TableRow>
    );
  };
  const isAnyTableDataExist =
    state.data && state.data.length > 0 && state.columns && state.columns.length > 0;
  return (
    <div id="Report-Table" data-id="Report-Table" className="my-2">
      {isAnyTableDataExist ? (
        <TableContainer className="max-h-full overflow-auto">
          <Table stickyHeader size="small">
            <TableHeader
              order={state.orderingDirection}
              orderBy={state.orderingBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {state.data && state.data.map((rows, idx) => createColumns(rows, idx))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        "No Data"
      )}
    </div>
  );
};

export default AssignedLawFirms;
